// @flow
import React, { Fragment } from 'react';
import { isBrowser } from 'react-device-detect';
import Button from 'components/common/Button';
import type { Meta } from 'store/modules/write';
import { IoMdGlobe } from 'react-icons/io';
import { MdLock } from 'react-icons/md';
import cx from 'classnames';
import './SubmitBoxAdditional.scss';

type Props = {
  realMeta: ?Meta,
  meta: Meta,
  body: string,
  urlSlug: ?string,
  username: string,
  onChangePrice(e: SyntheticInputEvent<HTMLInputElement>): void,
  onChangeSupplier(e: SyntheticInputEvent<HTMLInputElement>): void,
  onChangeProductUrl(e: SyntheticInputEvent<HTMLInputElement>): void,
  onChangePartnerUrl(e: SyntheticInputEvent<HTMLInputElement>): void,
  onChangeBrandUrl(e: SyntheticInputEvent<HTMLInputElement>): void,
  onChangeQuoteStatus(isPrivate: boolean): void,
  onChangeShortDescription(e: SyntheticInputEvent<HTMLInputElement>): void,
  onChangeUrlSlug(e: SyntheticInputEvent<HTMLInputElement>): void,
  onChangeEventAt(e: SyntheticInputEvent<HTMLInputElement>): void,
  onChangeEventStatus(isPrivate: boolean): void,
  onCancel(): void,
  onConfirm(): void,
  type: string,
};

const SubmitBoxAdditional = ({
  meta,
  username,
  urlSlug,
  onChangeShortDescription,
  onChangePrice,
  onChangeSupplier,
  onChangeProductUrl,
  onChangePartnerUrl,
  onChangeBrandUrl,
  onChangeQuoteStatus,
  onChangeUrlSlug,
  onChangeEventAt,
  onChangeEventStatus,
  onCancel,
  onConfirm,
  type,
}: Props) => (
  <div className="SubmitBoxAdditional">
    <div className="sections">
      <section>
        <div className="section-title">짧은설명</div>
        <textarea rows="4" onChange={onChangeShortDescription} value={meta.short_description} />
      </section>
      {type === 'product' && (
        <Fragment>
          <section>
            <div className="section-title">가격</div>
            <div className="price">
              <input value={meta.price} onChange={onChangePrice} />
            </div>
          </section>
          <section>
            <div className="section-title">제조사</div>
            <div className="supplier">
              <input value={meta.supplier} onChange={onChangeSupplier} />
            </div>
          </section>
          <section>
            <div className="section-title">출처 URL</div>
            <div className="productUrl">
              <input value={meta.productUrl} onChange={onChangeProductUrl} />
            </div>
          </section>
        </Fragment>
      )}
      {type === 'partner' && (
        <Fragment>
          <section>
            <div className="section-title">사이트 URL</div>
            <div className="productUrl">
              <input value={meta.partnerUrl} onChange={onChangePartnerUrl} />
            </div>
          </section>
        </Fragment>
      )}
      {type === 'brand' && (
        <Fragment>
          <section>
            <div className="section-title">브랜드 URL</div>
            <div className="productUrl">
              <input value={meta.brandUrl} onChange={onChangeBrandUrl} />
            </div>
          </section>
        </Fragment>
      )}
      <section>
        <div className="section-title">캐시바이 URL</div>
        <div className="url">
          <input value={urlSlug} onChange={onChangeUrlSlug} />
        </div>
      </section>
      {type === 'quote' && (
        <Fragment>
          <section>
            <div className="section-title">진행 여부</div>
            <div className="WriteVisibilitySelect">
              <div
                className={cx('item', { active: meta.quoteStatus })}
                onClick={() => onChangeQuoteStatus(true)}
              >
                <div className="item-content">
                  <IoMdGlobe />
                  종료
                </div>
              </div>
              <div
                className={cx('item', { active: !meta.quoteStatus })}
                onClick={() => onChangeQuoteStatus(false)}
              >
                <div className="item-content">
                  <MdLock />
                  진행중
                </div>
              </div>
              <div className={cx('active-slider', { right: !meta.quoteStatus })} />
            </div>
          </section>
        </Fragment>
      )}
      {type === 'event' && (
        <Fragment>
          <section>
            <div className="section-title">이벤트 날짜(ex: 20/11/27~20/12/06)</div>
            <div className="eventAt">
              <input value={meta.eventAt} onChange={onChangeEventAt} />
            </div>
          </section>
          <section>
            <div className="section-title">진행 여부</div>
            <div className="WriteVisibilitySelect">
              <div
                className={cx('item', { active: meta.eventStatus })}
                onClick={() => onChangeEventStatus(true)}
              >
                <div className="item-content">
                  <IoMdGlobe />
                  종료
                </div>
              </div>
              <div
                className={cx('item', { active: !meta.eventStatus })}
                onClick={() => onChangeEventStatus(false)}
              >
                <div className="item-content">
                  <MdLock />
                  진행중
                </div>
              </div>
              <div className={cx('active-slider', { right: !meta.eventStatus })} />
            </div>
          </section>
        </Fragment>
      )}
    </div>
    <div className="buttons">
      <Button theme="paper" onClick={onCancel} desktop={isBrowser}>
        취소
      </Button>
      <Button theme="paper" violetFont onClick={onConfirm} desktop={isBrowser}>
        확인
      </Button>
    </div>
  </div>
);

export default SubmitBoxAdditional;



// WEBPACK FOOTER //
// ./src/components/write/SubmitBoxAdditional/SubmitBoxAdditional.js